var render = function render(){var _vm=this,_c=_vm._self._c;return _c('lsDownLoad',_vm._g(_vm._b({ref:"downLoad",attrs:{"goToUrl":_vm.goToUrl}},'lsDownLoad',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }